import classnames from "classnames"
import Styles from "./MainCheckBox.module.scss";

interface MainCheckBoxProps {
  isChecked:boolean;
  disabled?: boolean;
  label?:string;
  onClick?: (state:boolean) => void;
}

const MainCheckBox = ({
  isChecked,
  label="",
  disabled=false,
  onClick,
}: MainCheckBoxProps) => {
  return (
    <div className={Styles.container}>
      <div className={Styles.toggle_switch}>
        <input type="checkbox" checked={isChecked} className={classnames(Styles.checkbox,disabled && Styles.disabled)}
          name={"checkbox"} id={"checkbox"} disabled={disabled} onClick={()=>{onClick?.(!isChecked)}} onChange={()=>{}}/>
        <label className={Styles.label} htmlFor={"checkbox"}>
          <span className={Styles.inner} />
          <span className={Styles.switch} />
        </label>
        {
          label && <div className={Styles.label}>
            {label}
          </div>
        }
      </div>
    </div>
  );
};

export default MainCheckBox;